"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementAdjustmentReversedV1 = exports.SettlementDisputeDebtReversedV1 = exports.SettlementDisputeFeeReversalRequestedV1 = exports.SettlementTransferRequestedV1 = exports.LedgerEntriesGeneratedV1 = exports.ChargebackAlertResolutionRequestedV1 = exports.GlobalChargebackCaseUpdatedV1 = exports.SaleRefundFailedV1 = exports.SalePartiallyRefundedV1 = exports.SaleRefundedV1 = exports.SaleDisputeWonV1 = exports.SaleChargedBackV1 = exports.SaleRefundRequestedV1 = exports.RecurringPaymentObservedV1 = exports.SubscriptionSetupConfirmedV1 = exports.SubscriptionAccessRequestedV1 = exports.SubscriptionRenewedV1 = exports.SubscriptionPastDueV1 = exports.InvoiceActionRequiredV1 = exports.InvoicePaymentFailedV1 = exports.SubscriptionCanceledV1 = exports.InvoiceScheduledV1 = exports.SubscriptionCreatedV1 = exports.CheckoutAbandonedV1 = exports.SaleRefusedV1 = exports.SalePaidV1 = exports.SaleCreatedV1 = exports.PlanUpdatedV1 = exports.PlanCreatedV1 = exports.OrderBumpCreatedV1 = exports.OfferCreatedV1 = exports.ProductCreatedV1 = exports.SaleLineSchema = exports.SaleLineSplitSchema = exports.SettlementTracePhaseSchema = exports.SaleLineKindSchema = exports.TrackingIdentifiersSchema = exports.CheckoutSkinExperimentSchema = exports.PaymentDetailsSchema = exports.LedgerEntriesRevokedReasonSchema = exports.DebtStatusSchema = exports.DebtOriginSchema = exports.ChargebackPreventionReferenceSchema = exports.RefundRequestedBySchema = exports.PercentageSchema = exports.LedgerEntryStatusSchema = exports.LedgerEntryTypeSchema = exports.PaymentMethodSchema = exports.ReceivingPeriodSchema = exports.GatewaySchema = void 0;
exports.MoneyEventSchema = exports.MoneyEventSchemas = exports.WithdrawalRevertedV1 = exports.WithdrawalCompletedV1 = exports.WithdrawalRefusedV1 = exports.WithdrawalApprovedV1 = exports.WithdrawalAnalysisV1 = exports.WithdrawalRequestedV1 = exports.WithdrawalConsumedV1 = exports.SettlementReconcileDivergenceDetectedV1 = exports.PremiacaoSolicitadaV1 = exports.PremiacaoStatusSchema = exports.CoproductionRemovedV1 = exports.CoproductionRemovalReasonSchema = exports.CoproductionInvitedV1 = exports.IdentityReserveSyncRequestedV1 = exports.SettlementDefaultReceivingPlanChangedV1 = exports.SettlementReceivingPlanChangedV1 = exports.IdentityConnectedAccountLinkedV1 = exports.IdentityKycOperationalUpdatedV1 = exports.IdentityUserProfileUpdatedV1 = exports.IdentityUserRegisteredV1 = exports.IdentityEmailVerificationRequestedV1 = exports.IdentityPasswordResetRequestedV1 = exports.DebtSettlementAppliedV1 = exports.SettlementDebtsCreatedV1 = exports.LedgerEntriesRevokedV1 = exports.SettlementAdjustmentReversed = exports.SettlementAdjustmentReversedV2 = void 0;
exports.parseMoneyEvent = parseMoneyEvent;
const zod_1 = require("zod");
const event_1 = require("./event");
const webhook_payloads_1 = require("./webhook-payloads");
const fee_snapshot_1 = require("./fee-snapshot");
const referrals_1 = require("./referrals");
exports.GatewaySchema = zod_1.z.enum(['STRIPE', 'MERCADO_PAGO', 'PAYPAL', 'BRASIL_BITCOIN']);
exports.ReceivingPeriodSchema = zod_1.z.enum(['D2', 'D5', 'D14', 'D30']);
exports.PaymentMethodSchema = zod_1.z.enum([
    'CREDIT_CARD',
    'PIX',
    'BOLETO',
    'PAYPAL',
    'APPLE_PAY',
    'GOOGLE_PAY',
    'AMAZON_PAY',
]);
exports.LedgerEntryTypeSchema = zod_1.z.enum(['USER', 'COMMISSION', 'VENDEPAY', 'RESERVE']);
exports.LedgerEntryStatusSchema = zod_1.z.enum([
    'PENDING',
    'PROCESSING',
    'PROCESSING_PARTIAL',
    'DEBT_RECOVERY_PROCESSING',
    'DEBT_RECOVERY_PROCESSING_PARTIAL',
    'PAID',
    'REVOKED',
    'DEBT_SETTLED',
    'DEBT_SETTLED_PARTIAL',
]);
exports.PercentageSchema = zod_1.z.string().regex(/^\d+(\.\d{1,3})?$/);
exports.RefundRequestedBySchema = zod_1.z.enum(['BUYER', 'SELLER', 'ADMIN', 'CHARGEBACK_ALERT']);
exports.ChargebackPreventionReferenceSchema = zod_1.z
    .object({
    caseId: zod_1.z.string().min(1),
    provider: zod_1.z.string().min(1),
    providerEventId: zod_1.z.string().min(1),
    providerAlertId: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.DebtOriginSchema = zod_1.z.enum(['CHARGEBACK', 'ESTORNO', 'GLOBAL_CHARGEBACK_FEE', 'FX_LOSS']);
exports.DebtStatusSchema = zod_1.z.enum(['PENDING', 'SETTLED', 'REVERSED']);
exports.LedgerEntriesRevokedReasonSchema = zod_1.z.enum(['REFUND', 'CHARGEBACK']);
exports.PaymentDetailsSchema = zod_1.z
    .object({
    billingCountry: zod_1.z.string().regex(/^[A-Z]{2}$/).optional(),
    cardCountry: zod_1.z.string().regex(/^[A-Z]{2}$/).optional(),
    providerAvailabilityStatus: zod_1.z.enum(['pending', 'available']).optional(),
    providerAvailabilityObservedAt: zod_1.z.string().datetime({ offset: true }).optional(),
    providerAvailableAt: zod_1.z.string().datetime({ offset: true }).optional(),
    cardBrand: zod_1.z.string().min(1).optional(),
    cardLast4: zod_1.z
        .string()
        .regex(/^\d{4}$/)
        .optional(),
    authorizationCode: zod_1.z.string().min(1).optional(),
    networkTransactionId: zod_1.z.string().min(1).optional(),
    nsu: zod_1.z.string().min(1).optional(),
    tid: zod_1.z.string().min(1).optional(),
    installments: zod_1.z.number().int().positive().optional(),
})
    .strict();
exports.CheckoutSkinExperimentSchema = zod_1.z
    .object({
    id: zod_1.z.literal('checkout-skin'),
    variant: zod_1.z.enum(['new', 'legacy']),
})
    .strict();
exports.TrackingIdentifiersSchema = zod_1.z
    .object({
    sourceUrl: zod_1.z.string().max(8192).url().optional(),
    fbclid: zod_1.z.string().min(1).optional(),
    ttclid: zod_1.z.string().min(1).optional(),
    gclid: zod_1.z.string().min(1).optional(),
    fbp: zod_1.z.string().min(1).optional(),
    fbc: zod_1.z.string().min(1).optional(),
    clientIp: zod_1.z.string().min(1).optional(),
    userAgent: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.SaleLineKindSchema = zod_1.z.enum(['PRINCIPAL', 'BUMP', 'UPSELL', 'DOWNSELL']);
exports.SettlementTracePhaseSchema = zod_1.z.string().min(1);
exports.SaleLineSplitSchema = zod_1.z
    .object({
    affiliateId: zod_1.z.string().min(1).optional(),
    affiliatePercentage: exports.PercentageSchema.optional(),
    coProducerId: zod_1.z.string().min(1).optional(),
    coProducerPercentage: exports.PercentageSchema.optional(),
    seedId: zod_1.z.string().min(1).optional(),
    seedPercentage: exports.PercentageSchema.optional(),
})
    .strict()
    .superRefine((split, ctx) => {
    assertParticipantTerms(ctx, 'affiliate', split.affiliateId, split.affiliatePercentage);
    assertParticipantTerms(ctx, 'coProducer', split.coProducerId, split.coProducerPercentage);
    assertParticipantTerms(ctx, 'seed', split.seedId, split.seedPercentage);
});
exports.SaleLineSchema = zod_1.z
    .object({
    lineId: zod_1.z.string().min(1),
    kind: exports.SaleLineKindSchema,
    offerId: zod_1.z.string().min(1),
    productId: zod_1.z.string().min(1),
    producerId: zod_1.z.string().min(1).optional(),
    amount: event_1.MonetaryValueSchema,
    settlementAmount: event_1.MonetaryValueSchema.optional(),
    split: exports.SaleLineSplitSchema,
})
    .strict();
const SaleLinesSchema = zod_1.z
    .array(exports.SaleLineSchema)
    .min(1)
    .superRefine((lines, ctx) => {
    const isFunnelStepOnly = lines.length === 1 && (lines[0]?.kind === 'UPSELL' || lines[0]?.kind === 'DOWNSELL');
    if (isFunnelStepOnly) {
        return;
    }
    const principalCount = lines.filter((line) => line.kind === 'PRINCIPAL').length;
    if (principalCount !== 1) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: [],
            message: 'lines deve conter exatamente uma linha PRINCIPAL',
        });
    }
});
exports.ProductCreatedV1 = (0, event_1.defineEvent)({
    type: 'catalog.product.created',
    version: 1,
    payload: zod_1.z
        .object({
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        name: zod_1.z.string().min(1),
        createdAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.OfferCreatedV1 = (0, event_1.defineEvent)({
    type: 'catalog.offer.created',
    version: 1,
    payload: zod_1.z
        .object({
        offerId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        price: event_1.MonetaryValueSchema,
        marketPrices: zod_1.z.array(event_1.MonetaryValueSchema).optional(),
        createdAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.OrderBumpCreatedV1 = (0, event_1.defineEvent)({
    type: 'catalog.order-bump.created',
    version: 1,
    payload: zod_1.z
        .object({
        orderBumpId: zod_1.z.string().min(1),
        ownerProductId: zod_1.z.string().min(1),
        targetOfferId: zod_1.z.string().min(1),
        planId: zod_1.z.string().min(1).optional(),
        price: event_1.MonetaryValueSchema,
        marketPrices: zod_1.z.array(event_1.MonetaryValueSchema).optional(),
        commissionable: zod_1.z.boolean(),
        merchandising: zod_1.z
            .object({
            title: zod_1.z.string().min(1),
            callToAction: zod_1.z.string().min(1),
            description: zod_1.z.string().min(1).optional(),
            imageUrl: zod_1.z.string().url().optional(),
        })
            .strict(),
        createdAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
const PlanBillingSchema = zod_1.z
    .object({
    billingPeriodUnit: zod_1.z.enum(['MINUTE', 'DAY', 'WEEK', 'MONTH', 'YEAR']),
    billingPeriodCount: zod_1.z.number().int().positive(),
    billingAnchorType: zod_1.z.enum(['IMMEDIATE', 'CALENDAR']),
    billingAnchorDayOfMonth: zod_1.z.number().int().min(1).max(31).optional(),
})
    .strict();
const PlanTrialSchema = zod_1.z
    .object({
    isTrialEnabled: zod_1.z.boolean(),
    trialType: zod_1.z.enum(['WITH_PAYMENT', 'PAID']).optional(),
    trialDays: zod_1.z.number().int().positive().optional(),
    trialPrice: event_1.MonetaryValueSchema.optional(),
})
    .strict();
const PlanRetrySchema = zod_1.z
    .object({
    maxRetryAttempts: zod_1.z.number().int().min(0),
    fixedDelayDays: zod_1.z.number().int().min(1),
})
    .strict();
const PlanGraceSchema = zod_1.z
    .object({
    gracePeriodEnabled: zod_1.z.boolean(),
    gracePeriodDays: zod_1.z.number().int().min(0),
})
    .strict();
exports.PlanCreatedV1 = (0, event_1.defineEvent)({
    type: 'catalog.plan.created',
    version: 1,
    payload: zod_1.z
        .object({
        planId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        name: zod_1.z.string().min(1),
        description: zod_1.z.string().optional(),
        benefits: zod_1.z.array(zod_1.z.string()).optional(),
        value: event_1.MonetaryValueSchema,
        billing: PlanBillingSchema,
        trial: PlanTrialSchema,
        retry: PlanRetrySchema,
        grace: PlanGraceSchema,
        createdAt: zod_1.z.string().datetime({ offset: true }),
        updatedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.PlanUpdatedV1 = (0, event_1.defineEvent)({
    type: 'catalog.plan.updated',
    version: 1,
    payload: zod_1.z
        .object({
        planId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        name: zod_1.z.string().min(1),
        description: zod_1.z.string().optional(),
        benefits: zod_1.z.array(zod_1.z.string()).optional(),
        value: event_1.MonetaryValueSchema,
        billing: PlanBillingSchema,
        trial: PlanTrialSchema,
        retry: PlanRetrySchema,
        grace: PlanGraceSchema,
        createdAt: zod_1.z.string().datetime({ offset: true }),
        updatedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.SaleCreatedV1 = (0, event_1.defineEvent)({
    type: 'payments.sale.created',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        sellerId: zod_1.z.string().min(1),
        receivingPeriod: exports.ReceivingPeriodSchema.optional(),
        affiliateId: zod_1.z.string().min(1).optional(),
        affiliatePercentage: exports.PercentageSchema.optional(),
        buyerId: zod_1.z.string().min(1).optional(),
        amount: event_1.MonetaryValueSchema,
        settlementAmount: event_1.MonetaryValueSchema.optional(),
        paymentMethod: exports.PaymentMethodSchema.optional(),
        gateway: exports.GatewaySchema.optional(),
        gatewayPaymentId: zod_1.z.string().min(1).optional(),
        payerName: zod_1.z.string().min(1).optional(),
        payerEmail: zod_1.z.string().email().optional(),
        payerPhone: zod_1.z.string().min(1).optional(),
        utm: webhook_payloads_1.UtmAttributionSchema.optional(),
        trackingIdentifiers: exports.TrackingIdentifiersSchema.optional(),
        piiConsentAt: zod_1.z.string().datetime({ offset: true }).optional(),
        experiment: exports.CheckoutSkinExperimentSchema.optional(),
        createdAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.SalePaidV1 = (0, event_1.defineEvent)({
    type: 'payments.sale.paid',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        sellerId: zod_1.z.string().min(1),
        receivingPeriod: exports.ReceivingPeriodSchema.optional(),
        feeSnapshot: fee_snapshot_1.SettlementFeeSnapshotV1Schema.optional(),
        reserveTerms: zod_1.z.array(zod_1.z.object({
            participantId: zod_1.z.string().min(1),
            percent: zod_1.z.number().int().min(1).max(100),
            days: zod_1.z.number().int().min(1).max(180),
        }).strict()).optional(),
        buyerPaidConversion: zod_1.z.literal(true).optional(),
        settlementDisposition: zod_1.z.enum(['DISTRIBUTE', 'HOLD_FOR_REFUND']).optional(),
        affiliateId: zod_1.z.string().min(1).optional(),
        affiliatePercentage: exports.PercentageSchema.optional(),
        coProducerId: zod_1.z.string().min(1).optional(),
        coProducerPercentage: exports.PercentageSchema.optional(),
        seedId: zod_1.z.string().min(1).optional(),
        seedPercentage: exports.PercentageSchema.optional(),
        buyerId: zod_1.z.string().min(1).optional(),
        subscriptionId: zod_1.z.string().min(1).optional(),
        isRenewal: zod_1.z.boolean().optional(),
        amountPaid: event_1.MonetaryValueSchema,
        settlementAmount: event_1.MonetaryValueSchema.optional(),
        providerSettlementAmount: event_1.MonetaryValueSchema.optional(),
        paymentMethod: exports.PaymentMethodSchema,
        gateway: exports.GatewaySchema,
        gatewayPaymentId: zod_1.z.string().min(1),
        payerName: zod_1.z.string().min(1).optional(),
        payerEmail: zod_1.z.string().email().optional(),
        payerPhone: zod_1.z.string().min(1).optional(),
        paymentDetails: exports.PaymentDetailsSchema.optional(),
        utm: webhook_payloads_1.UtmAttributionSchema.optional(),
        trackingIdentifiers: exports.TrackingIdentifiersSchema.optional(),
        piiConsentAt: zod_1.z.string().datetime({ offset: true }).optional(),
        experiment: exports.CheckoutSkinExperimentSchema.optional(),
        lines: SaleLinesSchema.optional(),
        recoveryAttribution: zod_1.z
            .object({
            channel: zod_1.z.literal('RECUPERAAI'),
            cartId: zod_1.z.string().min(1).optional(),
        })
            .strict()
            .optional(),
        paidAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.SaleRefusedV1 = (0, event_1.defineEvent)({
    type: 'payments.sale.refused',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        sellerId: zod_1.z.string().min(1),
        receivingPeriod: exports.ReceivingPeriodSchema.optional(),
        affiliateId: zod_1.z.string().min(1).optional(),
        affiliatePercentage: exports.PercentageSchema.optional(),
        coProducerId: zod_1.z.string().min(1).optional(),
        coProducerPercentage: exports.PercentageSchema.optional(),
        seedId: zod_1.z.string().min(1).optional(),
        seedPercentage: exports.PercentageSchema.optional(),
        amountPaid: event_1.MonetaryValueSchema,
        settlementAmount: event_1.MonetaryValueSchema.optional(),
        paymentMethod: exports.PaymentMethodSchema.optional(),
        gateway: exports.GatewaySchema.optional(),
        payerName: zod_1.z.string().min(1).optional(),
        payerEmail: zod_1.z.string().email().optional(),
        payerPhone: zod_1.z.string().min(1).optional(),
        refusedAt: zod_1.z.string().datetime({ offset: true }),
        reason: zod_1.z.string().min(1).optional(),
    })
        .strict(),
});
exports.CheckoutAbandonedV1 = (0, event_1.defineEvent)({
    type: 'checkout.abandoned',
    version: 1,
    payload: zod_1.z
        .object({
        checkoutSessionId: zod_1.z.string().min(1),
        checkoutId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        sellerId: zod_1.z.string().min(1),
        affiliateRef: zod_1.z.string().min(1).optional(),
        checkoutUrl: zod_1.z.string().url().optional(),
        buyerEmail: zod_1.z.string().email().optional(),
        buyerName: zod_1.z.string().min(1).optional(),
        buyerPhone: zod_1.z.string().min(1).optional(),
        utm: webhook_payloads_1.UtmAttributionSchema.optional(),
        trackingIdentifiers: exports.TrackingIdentifiersSchema.optional(),
        experiment: exports.CheckoutSkinExperimentSchema.optional(),
        startedAt: zod_1.z.string().datetime({ offset: true }),
        lastSeenAt: zod_1.z.string().datetime({ offset: true }),
        abandonedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.SubscriptionCreatedV1 = (0, event_1.defineEvent)({
    type: 'recurrence.subscription.created',
    version: 1,
    payload: zod_1.z
        .object({
        subscriptionId: zod_1.z.string().min(1),
        planId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        sellerId: zod_1.z.string().min(1),
        buyerId: zod_1.z.string().min(1).optional(),
        status: zod_1.z.enum(['TRIALING', 'ACTIVE', 'PAST_DUE', 'CANCELED']),
        createdAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.InvoiceScheduledV1 = (0, event_1.defineEvent)({
    type: 'recurrence.invoice.scheduled',
    version: 1,
    payload: zod_1.z
        .object({
        invoiceId: zod_1.z.string().min(1),
        subscriptionId: zod_1.z.string().min(1),
        cycleN: zod_1.z.number().int().positive(),
        amount: event_1.MonetaryValueSchema,
        dueAt: zod_1.z.string().datetime({ offset: true }),
        settlementSaleId: zod_1.z.string().min(1),
    })
        .strict(),
});
exports.SubscriptionCanceledV1 = (0, event_1.defineEvent)({
    type: 'recurrence.subscription.canceled',
    version: 1,
    payload: zod_1.z
        .object({
        subscriptionId: zod_1.z.string().min(1),
        planId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1).optional(),
        sellerId: zod_1.z.string().min(1).optional(),
        buyerId: zod_1.z.string().min(1).optional(),
        canceledAt: zod_1.z.string().datetime({ offset: true }),
        reason: zod_1.z.string().min(1).optional(),
    })
        .strict(),
});
exports.InvoicePaymentFailedV1 = (0, event_1.defineEvent)({
    type: 'recurrence.invoice.payment-failed',
    version: 1,
    payload: zod_1.z
        .object({
        invoiceId: zod_1.z.string().min(1),
        subscriptionId: zod_1.z.string().min(1),
        planId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        buyerId: zod_1.z.string().min(1).optional(),
        buyerEmail: zod_1.z.string().email().optional(),
        amount: event_1.MonetaryValueSchema,
        attempt: zod_1.z.number().int().positive(),
        status: zod_1.z.enum(['PAST_DUE', 'IN_GRACE', 'FAILED', 'CANCELED']),
        failedAt: zod_1.z.string().datetime({ offset: true }),
        nextAttemptAt: zod_1.z.string().datetime({ offset: true }).optional(),
        gracePeriodEndsAt: zod_1.z.string().datetime({ offset: true }).optional(),
        reason: zod_1.z.string().min(1).optional(),
    })
        .strict(),
});
exports.InvoiceActionRequiredV1 = (0, event_1.defineEvent)({
    type: 'recurrence.invoice.action-required',
    version: 1,
    payload: zod_1.z
        .object({
        invoiceId: zod_1.z.string().min(1),
        subscriptionId: zod_1.z.string().min(1),
        planId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        buyerId: zod_1.z.string().min(1).optional(),
        buyerEmail: zod_1.z.string().email().optional(),
        amount: event_1.MonetaryValueSchema,
        attempt: zod_1.z.number().int().positive(),
        status: zod_1.z.literal('AWAITING_ACTION'),
        actionRequiredAt: zod_1.z.string().datetime({ offset: true }),
        nextAttemptAt: zod_1.z.string().datetime({ offset: true }).optional(),
        gracePeriodEndsAt: zod_1.z.string().datetime({ offset: true }).optional(),
        reason: zod_1.z.string().min(1).optional(),
    })
        .strict(),
});
exports.SubscriptionPastDueV1 = (0, event_1.defineEvent)({
    type: 'recurrence.subscription.past-due',
    version: 1,
    payload: zod_1.z
        .object({
        subscriptionId: zod_1.z.string().min(1),
        invoiceId: zod_1.z.string().min(1),
        planId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        sellerId: zod_1.z.string().min(1).optional(),
        buyerId: zod_1.z.string().min(1).optional(),
        buyerEmail: zod_1.z.string().email().optional(),
        amount: event_1.MonetaryValueSchema,
        pastDueAt: zod_1.z.string().datetime({ offset: true }),
        nextAttemptAt: zod_1.z.string().datetime({ offset: true }).optional(),
        gracePeriodEndsAt: zod_1.z.string().datetime({ offset: true }).optional(),
    })
        .strict(),
});
exports.SubscriptionRenewedV1 = (0, event_1.defineEvent)({
    type: 'recurrence.subscription.renewed',
    version: 1,
    payload: zod_1.z
        .object({
        subscriptionId: zod_1.z.string().min(1),
        invoiceId: zod_1.z.string().min(1),
        saleId: zod_1.z.string().min(1),
        cycleN: zod_1.z.number().int().positive(),
        planId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        sellerId: zod_1.z.string().min(1),
        buyerId: zod_1.z.string().min(1).optional(),
        buyerEmail: zod_1.z.string().email().optional(),
        amount: event_1.MonetaryValueSchema,
        renewedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.SubscriptionAccessRequestedV1 = (0, event_1.defineEvent)({
    type: 'recurrence.subscription.access-requested',
    version: 1,
    payload: zod_1.z.object({ subscriptionId: zod_1.z.string().min(1), codeId: zod_1.z.string().uuid() }).strict(),
});
exports.SubscriptionSetupConfirmedV1 = (0, event_1.defineEvent)({
    type: 'payments.subscription-setup.confirmed',
    version: 1,
    payload: zod_1.z
        .object({
        setupIntentId: zod_1.z.string().min(1),
        subscriptionId: zod_1.z.string().min(1).optional(),
        savedPaymentMethodRef: zod_1.z.string().min(1),
        customerRef: zod_1.z.string().min(1).optional(),
        confirmedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.RecurringPaymentObservedV1 = (0, event_1.defineEvent)({
    type: 'payments.recurring-payment.observed',
    version: 1,
    payload: zod_1.z
        .object({
        invoiceId: zod_1.z.string().min(1),
        subscriptionId: zod_1.z.string().min(1),
        gatewayPaymentId: zod_1.z.string().min(1),
        gatewayChargeId: zod_1.z.string().min(1).optional(),
        recurringAttemptKey: zod_1.z.string().min(1).optional(),
        status: zod_1.z.enum(['SUCCEEDED', 'FAILED']),
        paymentDetails: exports.PaymentDetailsSchema.optional(),
        observedAmount: event_1.MonetaryValueSchema.optional(),
        providerSettlementAmount: event_1.MonetaryValueSchema.optional(),
        /** @deprecated Legacy name emitted briefly by the first settlement implementation. */
        settlementAmount: event_1.MonetaryValueSchema.optional(),
        reason: zod_1.z.string().min(1).optional(),
        failureCode: zod_1.z.string().min(1).optional(),
        occurredAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.SaleRefundRequestedV1 = (0, event_1.defineEvent)({
    type: 'payments.sale.refund-requested',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        requestedAt: zod_1.z.string().datetime({ offset: true }),
        reason: zod_1.z.string().min(1).optional(),
        requestedBy: exports.RefundRequestedBySchema.optional(),
        chargebackPrevention: exports.ChargebackPreventionReferenceSchema.optional(),
    })
        .strict(),
});
exports.SaleChargedBackV1 = (0, event_1.defineEvent)({
    type: 'payments.sale.charged-back',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1).optional(),
        amountPaid: event_1.MonetaryValueSchema,
        gatewayDisputeId: zod_1.z.string().min(1).optional(),
        cumulativeDisputedAmount: event_1.MonetaryValueSchema.optional(),
        allocationRanges: zod_1.z.array(zod_1.z.object({
            start: event_1.MonetaryValueSchema,
            end: event_1.MonetaryValueSchema,
        }).strict()).min(1).optional(),
        allocationBasis: zod_1.z.object({
            amountPaid: event_1.MonetaryValueSchema,
            settlementAmount: event_1.MonetaryValueSchema.optional(),
            lines: SaleLinesSchema.optional(),
        }).strict().optional(),
        settlementAmount: event_1.MonetaryValueSchema.optional(),
        producerId: zod_1.z.string().min(1),
        sellerId: zod_1.z.string().min(1),
        affiliateId: zod_1.z.string().min(1).optional(),
        affiliatePercentage: exports.PercentageSchema.optional(),
        coProducerId: zod_1.z.string().min(1).optional(),
        coProducerPercentage: exports.PercentageSchema.optional(),
        seedId: zod_1.z.string().min(1).optional(),
        seedPercentage: exports.PercentageSchema.optional(),
        lines: SaleLinesSchema.optional(),
        gateway: exports.GatewaySchema.optional(),
        chargedBackAt: zod_1.z.string().datetime({ offset: true }),
        reason: zod_1.z.string().min(1).optional(),
    })
        .strict(),
});
exports.SaleDisputeWonV1 = (0, event_1.defineEvent)({
    type: 'payments.sale.dispute-won',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        gateway: zod_1.z.literal('STRIPE'),
        gatewayPaymentId: zod_1.z.string().min(1),
        gatewayDisputeId: zod_1.z.string().min(1),
        wonAt: zod_1.z.string().datetime({ offset: true }),
        reverseChargeFee: zod_1.z.boolean().optional(),
    })
        .strict(),
});
exports.SaleRefundedV1 = (0, event_1.defineEvent)({
    type: 'payments.sale.refunded',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1).optional(),
        amountPaid: event_1.MonetaryValueSchema,
        cumulativeRefundedAmount: event_1.MonetaryValueSchema.optional(),
        allocationBasis: zod_1.z.object({
            amountPaid: event_1.MonetaryValueSchema,
            settlementAmount: event_1.MonetaryValueSchema.optional(),
            lines: SaleLinesSchema.optional(),
        }).strict().optional(),
        settlementAmount: event_1.MonetaryValueSchema.optional(),
        producerId: zod_1.z.string().min(1),
        sellerId: zod_1.z.string().min(1),
        affiliateId: zod_1.z.string().min(1).optional(),
        affiliatePercentage: exports.PercentageSchema.optional(),
        coProducerId: zod_1.z.string().min(1).optional(),
        coProducerPercentage: exports.PercentageSchema.optional(),
        seedId: zod_1.z.string().min(1).optional(),
        seedPercentage: exports.PercentageSchema.optional(),
        lines: SaleLinesSchema.optional(),
        gateway: exports.GatewaySchema.optional(),
        gatewayRefundId: zod_1.z.string().min(1).optional(),
        refundedAt: zod_1.z.string().datetime({ offset: true }),
        preventedChargeback: zod_1.z.boolean().optional(),
        alertEventId: zod_1.z.string().min(1).optional(),
        chargebackPrevention: exports.ChargebackPreventionReferenceSchema.optional(),
    })
        .strict(),
});
exports.SalePartiallyRefundedV1 = (0, event_1.defineEvent)({
    type: 'payments.sale.partially-refunded',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1).optional(),
        amountPaid: event_1.MonetaryValueSchema,
        allocationBasis: zod_1.z.object({
            amountPaid: event_1.MonetaryValueSchema,
            settlementAmount: event_1.MonetaryValueSchema.optional(),
            lines: SaleLinesSchema.optional(),
        }).strict().optional(),
        cumulativeRefundedAmount: event_1.MonetaryValueSchema,
        settlementAmount: event_1.MonetaryValueSchema.optional(),
        producerId: zod_1.z.string().min(1),
        sellerId: zod_1.z.string().min(1),
        affiliateId: zod_1.z.string().min(1).optional(),
        affiliatePercentage: exports.PercentageSchema.optional(),
        coProducerId: zod_1.z.string().min(1).optional(),
        coProducerPercentage: exports.PercentageSchema.optional(),
        seedId: zod_1.z.string().min(1).optional(),
        seedPercentage: exports.PercentageSchema.optional(),
        lines: SaleLinesSchema.optional(),
        gateway: exports.GatewaySchema.optional(),
        gatewayRefundId: zod_1.z.string().min(1),
        refundedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.SaleRefundFailedV1 = (0, event_1.defineEvent)({
    type: 'payments.sale.refund-failed',
    version: 1,
    payload: zod_1.z.object({
        saleId: zod_1.z.string().min(1), gatewayRefundId: zod_1.z.string().min(1), failedAt: zod_1.z.string().datetime({ offset: true }),
        amount: event_1.MonetaryValueSchema,
    }).strict(),
});
exports.GlobalChargebackCaseUpdatedV1 = (0, event_1.defineEvent)({
    type: 'global-chargeback.case.updated',
    version: 1,
    payload: zod_1.z
        .object({
        caseId: zod_1.z.string().min(1),
        provider: zod_1.z.string().min(1),
        providerEventId: zod_1.z.string().min(1),
        status: zod_1.z.enum([
            'RECEIVED',
            'UNMATCHED',
            'MATCHED',
            'PREVENTED',
            'ALREADY_DISPUTED',
            'NOT_FOUND',
            'MANUAL_REQUIRED',
            'DISMISSED',
            'FAILED',
        ]),
        saleId: zod_1.z.string().min(1).optional(),
        updatedAt: zod_1.z.string().datetime({ offset: true }),
        reason: zod_1.z.string().min(1).optional(),
    })
        .strict(),
});
exports.ChargebackAlertResolutionRequestedV1 = (0, event_1.defineEvent)({
    type: 'global-chargeback.alert-resolution.requested',
    version: 1,
    payload: zod_1.z
        .object({
        provider: zod_1.z.enum(['PAYLAB', 'CHARGEBLAST']),
        providerEventId: zod_1.z.string().min(1),
        providerAlertId: zod_1.z.string().min(1),
        resolution: zod_1.z.enum([
            'ACCOUNT_SUSPENDED',
            'RESOLVED',
            'NOT_FOUND',
            'ALREADY_REFUNDED',
            'ALREADY_CHARGEBACK',
            'DUPLICATE',
        ]),
        caseId: zod_1.z.string().min(1),
        saleId: zod_1.z.string().min(1).optional(),
    })
        .strict(),
});
exports.LedgerEntriesGeneratedV1 = (0, event_1.defineEvent)({
    type: 'settlement.ledger-entries.generated',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        amountPaid: event_1.MonetaryValueSchema,
        totalAllocated: event_1.MonetaryValueSchema,
        ledgerEntries: zod_1.z
            .array(zod_1.z
            .object({
            id: zod_1.z.string().min(1).optional(),
            type: exports.LedgerEntryTypeSchema,
            recipientId: zod_1.z.string().min(1).optional(),
            lineId: zod_1.z.string().min(1).optional(),
            offerId: zod_1.z.string().min(1).optional(),
            kind: exports.SaleLineKindSchema.optional(),
            phase: exports.SettlementTracePhaseSchema.optional(),
            role: zod_1.z.string().min(1).optional(),
            amount: event_1.MonetaryValueSchema,
            availableAt: zod_1.z.string().datetime({ offset: true }),
            status: exports.LedgerEntryStatusSchema,
            source: zod_1.z.string().min(1),
        })
            .strict())
            .min(1),
    })
        .strict(),
});
exports.SettlementTransferRequestedV1 = (0, event_1.defineEvent)({
    type: 'settlement.transfer.requested',
    version: 1,
    payload: zod_1.z.object({
        transferId: zod_1.z.string().min(1),
        saleId: zod_1.z.string().min(1),
        requestedAt: zod_1.z.string().datetime({ offset: true }),
    }).strict(),
});
exports.SettlementDisputeFeeReversalRequestedV1 = (0, event_1.defineEvent)({
    type: 'settlement.dispute-fee.reversal-requested',
    version: 1,
    payload: zod_1.z.object({
        saleId: zod_1.z.string().min(1),
        gatewayDisputeId: zod_1.z.string().min(1),
        requestedAt: zod_1.z.string().datetime({ offset: true }),
    }).strict(),
});
exports.SettlementDisputeDebtReversedV1 = (0, event_1.defineEvent)({
    type: 'settlement.dispute-debt.reversed',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        gatewayDisputeId: zod_1.z.string().min(1),
        reversedAt: zod_1.z.string().datetime({ offset: true }),
        debts: zod_1.z
            .array(zod_1.z
            .object({
            debtId: zod_1.z.string().min(1),
            recipientId: zod_1.z.string().min(1),
            role: zod_1.z.literal('referral').optional(),
            lineId: zod_1.z.string().min(1).optional(),
            originalAmount: event_1.MonetaryValueSchema,
            outstandingAmount: event_1.MonetaryValueSchema,
            restoredAmount: event_1.MonetaryValueSchema,
            restoredLedgerEntryId: zod_1.z.string().min(1).optional(),
            restoredSources: zod_1.z.array(zod_1.z.object({
                saleId: zod_1.z.string().min(1),
                ledgerEntryId: zod_1.z.string().min(1),
                amount: event_1.MonetaryValueSchema,
                type: zod_1.z.enum(['COMMISSION', 'RESERVE']).optional(),
                availableAt: zod_1.z.string().datetime({ offset: true }).optional(),
            }).strict()).min(1).optional(),
        })
            .strict())
            .min(1),
    })
        .strict(),
});
exports.SettlementAdjustmentReversedV1 = (0, event_1.defineEvent)({
    type: 'settlement.adjustment.reversed',
    version: 1,
    payload: exports.SettlementDisputeDebtReversedV1.payload.omit({ gatewayDisputeId: true }).extend({
        adjustmentId: zod_1.z.string().min(1),
        reason: zod_1.z.enum(['FX_RECONCILED']),
    }).strict(),
});
exports.SettlementAdjustmentReversedV2 = (0, event_1.defineEvent)({
    type: 'settlement.adjustment.reversed',
    version: 2,
    payload: exports.SettlementAdjustmentReversedV1.payload.extend({ reason: zod_1.z.enum(['FX_RECONCILED', 'REFUND_FAILED']) }).strict(),
});
exports.SettlementAdjustmentReversed = {
    type: exports.SettlementAdjustmentReversedV1.type,
    parse: zod_1.z.discriminatedUnion('version', [exports.SettlementAdjustmentReversedV1.schema, exports.SettlementAdjustmentReversedV2.schema]).parse,
};
exports.LedgerEntriesRevokedV1 = (0, event_1.defineEvent)({
    type: 'settlement.ledger-entries.revoked',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        revokedAt: zod_1.z.string().datetime({ offset: true }),
        reason: exports.LedgerEntriesRevokedReasonSchema.optional(),
        ledgerEntries: zod_1.z
            .array(zod_1.z
            .object({
            id: zod_1.z.string().min(1),
            type: exports.LedgerEntryTypeSchema,
            recipientId: zod_1.z.string().min(1).optional(),
            lineId: zod_1.z.string().min(1).optional(),
            offerId: zod_1.z.string().min(1).optional(),
            kind: exports.SaleLineKindSchema.optional(),
            phase: exports.SettlementTracePhaseSchema.optional(),
            amount: event_1.MonetaryValueSchema,
        })
            .strict())
            .min(1),
    })
        .strict(),
});
exports.SettlementDebtsCreatedV1 = (0, event_1.defineEvent)({
    type: 'settlement.debts.created',
    version: 1,
    payload: zod_1.z
        .object({
        saleId: zod_1.z.string().min(1),
        origin: exports.DebtOriginSchema,
        fx: zod_1.z.object({
            referenceId: zod_1.z.string().min(1),
            originalBasis: event_1.MonetaryValueSchema,
            providerDebit: event_1.MonetaryValueSchema,
            loss: event_1.MonetaryValueSchema,
            originalTransactionId: zod_1.z.string().min(1),
            transactionIds: zod_1.z.array(zod_1.z.string().min(1)),
        }).strict().optional(),
        debts: zod_1.z
            .array(zod_1.z
            .object({
            debtId: zod_1.z.string().min(1),
            recipientId: zod_1.z.string().min(1),
            role: zod_1.z.literal('referral').optional(),
            lineId: zod_1.z.string().min(1).optional(),
            offerId: zod_1.z.string().min(1).optional(),
            kind: exports.SaleLineKindSchema.optional(),
            phase: exports.SettlementTracePhaseSchema.optional(),
            amount: event_1.MonetaryValueSchema,
        })
            .strict())
            .min(1),
        createdAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.DebtSettlementAppliedV1 = (0, event_1.defineEvent)({
    type: 'settlement.debt.settlement-applied',
    version: 1,
    payload: zod_1.z
        .object({
        role: zod_1.z.literal('referral').optional(),
        debtId: zod_1.z.string().min(1),
        saleId: zod_1.z.string().min(1),
        recipientId: zod_1.z.string().min(1),
        settledAmount: event_1.MonetaryValueSchema,
        remainingAmount: event_1.MonetaryValueSchema,
        status: exports.DebtStatusSchema,
        consumedLedgerEntries: zod_1.z
            .array(zod_1.z
            .object({
            ledgerEntryId: zod_1.z.string().min(1),
            ledgerEntryAmount: event_1.MonetaryValueSchema.optional(),
            consumedAmount: event_1.MonetaryValueSchema,
            remainderLedgerEntryId: zod_1.z.string().min(1).optional(),
            saleId: zod_1.z.string().min(1).optional(),
            type: exports.LedgerEntryTypeSchema.optional(),
            kind: exports.SaleLineKindSchema.optional(),
            lineId: zod_1.z.string().min(1).optional(),
            availableAt: zod_1.z.string().datetime({ offset: true }).optional(),
        })
            .strict())
            .min(1),
    })
        .strict(),
});
exports.IdentityPasswordResetRequestedV1 = (0, event_1.defineEvent)({
    type: 'identity.password.reset-requested',
    version: 1,
    payload: zod_1.z
        .object({
        email: zod_1.z.string().email(),
        name: zod_1.z.string().min(1).optional(),
        userId: zod_1.z.string().min(1).optional(),
        resetToken: zod_1.z.string().min(1),
        resetUrl: zod_1.z.string().url(),
        expiresAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.IdentityEmailVerificationRequestedV1 = (0, event_1.defineEvent)({
    type: 'identity.email.verification-requested',
    version: 1,
    payload: zod_1.z
        .object({
        userId: zod_1.z.string().min(1),
        email: zod_1.z.string().email(),
        name: zod_1.z.string().min(1).optional(),
        verificationToken: zod_1.z.string().min(1),
        verificationUrl: zod_1.z.string().url(),
        expiresAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.IdentityUserRegisteredV1 = (0, event_1.defineEvent)({
    type: 'identity.user-registered',
    version: 1,
    payload: zod_1.z.object({ userId: zod_1.z.string().min(1) }).strict(),
});
exports.IdentityUserProfileUpdatedV1 = (0, event_1.defineEvent)({
    type: 'identity.user-profile-updated',
    version: 1,
    payload: zod_1.z.object({ userId: zod_1.z.string().min(1) }).strict(),
});
exports.IdentityKycOperationalUpdatedV1 = (0, event_1.defineEvent)({
    type: 'identity.kyc-operational-updated',
    version: 1,
    payload: zod_1.z.object({ userId: zod_1.z.string().min(1) }).strict(),
});
exports.IdentityConnectedAccountLinkedV1 = (0, event_1.defineEvent)({
    type: 'identity.connected-account-linked',
    version: 1,
    payload: zod_1.z.object({
        linkId: zod_1.z.string().uuid(),
        userId: zod_1.z.string().min(1),
        accountId: zod_1.z.string().startsWith('acct_'),
        platformId: zod_1.z.string().startsWith('acct_'),
        livemode: zod_1.z.boolean(),
    }).strict(),
});
exports.SettlementReceivingPlanChangedV1 = (0, event_1.defineEvent)({
    type: 'settlement.receiving-plan-changed',
    version: 1,
    payload: zod_1.z.object({
        userId: zod_1.z.string().min(1),
        versionId: zod_1.z.string().uuid(),
    }).strict(),
});
exports.SettlementDefaultReceivingPlanChangedV1 = (0, event_1.defineEvent)({
    type: 'settlement.default-receiving-plan-changed',
    version: 1,
    payload: zod_1.z.object({
        versionId: zod_1.z.string().uuid(),
    }).strict(),
});
exports.IdentityReserveSyncRequestedV1 = (0, event_1.defineEvent)({
    type: 'identity.reserve-sync-requested',
    version: 1,
    payload: zod_1.z.object({
        userId: zod_1.z.string().min(1),
        linkId: zod_1.z.string().uuid(),
        defaultVersionId: zod_1.z.string().uuid(),
    }).strict(),
});
exports.CoproductionInvitedV1 = (0, event_1.defineEvent)({
    type: 'partnerships.coproduction.invited',
    version: 1,
    payload: zod_1.z
        .object({
        inviteId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        coProducerEmail: zod_1.z.string().email(),
        percentage: zod_1.z.string().min(1),
        token: zod_1.z.string().min(1),
        expiresAt: zod_1.z.string().datetime({ offset: true }).optional(),
    })
        .strict(),
});
exports.CoproductionRemovalReasonSchema = zod_1.z.enum([
    'INVITE_REJECTED',
    'COPRODUCER_LEFT',
    'PRODUCER_REMOVED',
]);
exports.CoproductionRemovedV1 = (0, event_1.defineEvent)({
    type: 'partnerships.coproduction.removed',
    version: 1,
    payload: zod_1.z
        .object({
        inviteId: zod_1.z.string().min(1),
        productId: zod_1.z.string().min(1),
        producerId: zod_1.z.string().min(1),
        coProducerId: zod_1.z.string().min(1),
        reason: exports.CoproductionRemovalReasonSchema,
        removedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.PremiacaoStatusSchema = zod_1.z.enum(['PENDENTE', 'ATENDIDO']);
exports.PremiacaoSolicitadaV1 = (0, event_1.defineEvent)({
    type: 'premiacao.solicitada',
    version: 1,
    payload: zod_1.z
        .object({
        premiacaoId: zod_1.z.string().min(1),
        usuarioId: zod_1.z.string().min(1),
        metaId: zod_1.z.string().min(1),
        valorMeta: event_1.MonetaryValueSchema,
        status: exports.PremiacaoStatusSchema,
        endereco: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
        dataSolicitacao: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.SettlementReconcileDivergenceDetectedV1 = (0, event_1.defineEvent)({
    type: 'settlement.reconcile.divergence.detected',
    version: 1,
    payload: zod_1.z
        .object({
        divergenceId: zod_1.z.string().min(1),
        scope: zod_1.z.enum(['PAYMENT', 'REFUND', 'CHARGEBACK']),
        reason: zod_1.z.enum([
            'PAYMENT_NOT_FOUND',
            'PAYMENT_STATUS_UNEXPECTED',
            'PAYMENT_AMOUNT_MISMATCH',
            'PAYMENT_CURRENCY_MISMATCH',
            'PAYMENT_SETTLEMENT_FX_DELTA',
            'PAYMENT_SETTLEMENT_AMOUNT_MISMATCH',
            'PAYMENT_SETTLEMENT_CURRENCY_MISMATCH',
            'PAYMENT_ORPHANED',
            'REFUND_NOT_FOUND',
            'REFUND_STATUS_UNEXPECTED',
            'REFUND_AMOUNT_MISMATCH',
            'REFUND_CURRENCY_MISMATCH',
            'CHARGEBACK_NOT_FOUND',
            'CHARGEBACK_STATUS_UNEXPECTED',
            'CHARGEBACK_AMOUNT_MISMATCH',
            'CHARGEBACK_CURRENCY_MISMATCH',
        ]),
        subjectId: zod_1.z.string().min(1).optional(),
        ledgerEntryId: zod_1.z.string().min(1).optional(),
        saleId: zod_1.z.string().min(1).optional(),
        recipientId: zod_1.z.string().min(1).optional(),
        withdrawalId: zod_1.z.string().min(1).optional(),
        gatewayPaymentId: zod_1.z.string().min(1).optional(),
        gatewayRefundId: zod_1.z.string().min(1).optional(),
        gatewayDisputeId: zod_1.z.string().min(1).optional(),
        basis: zod_1.z.enum(['PRESENTMENT', 'SETTLEMENT']).optional(),
        expectedAmount: event_1.MonetaryValueSchema,
        observedAmount: event_1.MonetaryValueSchema.optional(),
        status: zod_1.z.enum(['OPEN', 'RESOLVED', 'ACKED']).optional(),
        detectedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.WithdrawalConsumedV1 = (0, event_1.defineEvent)({
    type: 'wallet.withdrawal.consumed',
    version: 1,
    payload: zod_1.z
        .object({
        withdrawalId: zod_1.z.string().min(1),
        userId: zod_1.z.string().min(1),
        amount: event_1.MonetaryValueSchema,
        sourceAmount: event_1.MonetaryValueSchema.optional(),
        consumedLedgerEntries: zod_1.z
            .array(zod_1.z
            .object({
            ledgerEntryId: zod_1.z.string().min(1),
            consumedAmount: event_1.MonetaryValueSchema,
            status: zod_1.z.enum(['PROCESSING', 'PROCESSING_PARTIAL']),
            remainderLedgerEntryId: zod_1.z.string().min(1).optional(),
        })
            .strict())
            .min(1),
        consumedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.WithdrawalRequestedV1 = (0, event_1.defineEvent)({
    type: 'wallet.withdrawal.requested',
    version: 1,
    payload: zod_1.z
        .object({
        withdrawalId: zod_1.z.string().min(1),
        userId: zod_1.z.string().min(1),
        payoutDestinationId: zod_1.z.string().min(1),
        amount: event_1.MonetaryValueSchema,
        sourceAmount: event_1.MonetaryValueSchema.optional(),
        destinationAmount: event_1.MonetaryValueSchema.optional(),
        netAmount: event_1.MonetaryValueSchema.optional(),
        fee: event_1.MonetaryValueSchema.optional(),
        iof: event_1.MonetaryValueSchema.optional(),
        spread: event_1.MonetaryValueSchema.optional(),
        exchangeRate: zod_1.z.string().min(1).optional(),
        idempotencyKey: zod_1.z.string().min(1),
        requestedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.WithdrawalAnalysisV1 = (0, event_1.defineEvent)({
    type: 'wallet.withdrawal.analysis',
    version: 1,
    payload: zod_1.z
        .object({
        withdrawalId: zod_1.z.string().min(1),
        userId: zod_1.z.string().min(1),
        status: zod_1.z.literal('ANALYSIS'),
        sourceAmount: event_1.MonetaryValueSchema.optional(),
        analyzedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.WithdrawalApprovedV1 = (0, event_1.defineEvent)({
    type: 'wallet.withdrawal.approved',
    version: 1,
    payload: zod_1.z
        .object({
        withdrawalId: zod_1.z.string().min(1),
        userId: zod_1.z.string().min(1),
        status: zod_1.z.literal('APPROVED'),
        sourceAmount: event_1.MonetaryValueSchema.optional(),
        approvedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.WithdrawalRefusedV1 = (0, event_1.defineEvent)({
    type: 'wallet.withdrawal.refused',
    version: 1,
    payload: zod_1.z
        .object({
        withdrawalId: zod_1.z.string().min(1),
        userId: zod_1.z.string().min(1),
        status: zod_1.z.literal('REFUSED'),
        sourceAmount: event_1.MonetaryValueSchema.optional(),
        refusedAt: zod_1.z.string().datetime({ offset: true }),
        reason: zod_1.z.string().min(1).optional(),
    })
        .strict(),
});
exports.WithdrawalCompletedV1 = (0, event_1.defineEvent)({
    type: 'wallet.withdrawal.completed',
    version: 1,
    payload: zod_1.z
        .object({
        withdrawalId: zod_1.z.string().min(1),
        userId: zod_1.z.string().min(1),
        status: zod_1.z.enum(['COMPLETED', 'REFUSED', 'CANCELED']),
        sourceAmount: event_1.MonetaryValueSchema.optional(),
        payoutId: zod_1.z.string().min(1).optional(),
        reason: zod_1.z.string().min(1).optional(),
        completedAt: zod_1.z.string().datetime({ offset: true }),
    })
        .strict(),
});
exports.WithdrawalRevertedV1 = (0, event_1.defineEvent)({
    type: 'wallet.withdrawal.reverted',
    version: 1,
    payload: zod_1.z
        .object({
        withdrawalId: zod_1.z.string().min(1),
        userId: zod_1.z.string().min(1),
        sourceAmount: event_1.MonetaryValueSchema.optional(),
        revertedAt: zod_1.z.string().datetime({ offset: true }),
        reason: zod_1.z.string().min(1).optional(),
    })
        .strict(),
});
const MoneyEventV1Schemas = [
    referrals_1.ReferralCommissionAllocatedV1.schema,
    exports.ProductCreatedV1.schema,
    exports.OfferCreatedV1.schema,
    exports.OrderBumpCreatedV1.schema,
    exports.PlanCreatedV1.schema,
    exports.PlanUpdatedV1.schema,
    exports.SaleCreatedV1.schema,
    exports.SalePaidV1.schema,
    exports.SaleRefusedV1.schema,
    exports.CheckoutAbandonedV1.schema,
    exports.SubscriptionCreatedV1.schema,
    exports.InvoiceScheduledV1.schema,
    exports.SubscriptionCanceledV1.schema,
    exports.InvoicePaymentFailedV1.schema,
    exports.InvoiceActionRequiredV1.schema,
    exports.SubscriptionPastDueV1.schema,
    exports.SubscriptionRenewedV1.schema,
    exports.SubscriptionAccessRequestedV1.schema,
    exports.SubscriptionSetupConfirmedV1.schema,
    exports.RecurringPaymentObservedV1.schema,
    exports.SaleRefundRequestedV1.schema,
    exports.SaleChargedBackV1.schema,
    exports.SaleDisputeWonV1.schema,
    exports.SaleRefundedV1.schema,
    exports.SaleRefundFailedV1.schema,
    exports.SalePartiallyRefundedV1.schema,
    exports.GlobalChargebackCaseUpdatedV1.schema,
    exports.ChargebackAlertResolutionRequestedV1.schema,
    exports.LedgerEntriesGeneratedV1.schema,
    exports.SettlementTransferRequestedV1.schema,
    exports.SettlementDisputeDebtReversedV1.schema,
    exports.SettlementAdjustmentReversedV1.schema,
    exports.SettlementDisputeFeeReversalRequestedV1.schema,
    exports.LedgerEntriesRevokedV1.schema,
    exports.SettlementDebtsCreatedV1.schema,
    exports.DebtSettlementAppliedV1.schema,
    exports.IdentityPasswordResetRequestedV1.schema,
    exports.IdentityEmailVerificationRequestedV1.schema,
    exports.IdentityConnectedAccountLinkedV1.schema,
    exports.IdentityUserRegisteredV1.schema,
    exports.IdentityUserProfileUpdatedV1.schema,
    exports.IdentityKycOperationalUpdatedV1.schema,
    exports.SettlementReceivingPlanChangedV1.schema,
    exports.SettlementDefaultReceivingPlanChangedV1.schema,
    exports.IdentityReserveSyncRequestedV1.schema,
    exports.CoproductionInvitedV1.schema,
    exports.CoproductionRemovedV1.schema,
    exports.PremiacaoSolicitadaV1.schema,
    exports.SettlementReconcileDivergenceDetectedV1.schema,
    exports.WithdrawalConsumedV1.schema,
    exports.WithdrawalRequestedV1.schema,
    exports.WithdrawalAnalysisV1.schema,
    exports.WithdrawalApprovedV1.schema,
    exports.WithdrawalRefusedV1.schema,
    exports.WithdrawalCompletedV1.schema,
    exports.WithdrawalRevertedV1.schema,
];
exports.MoneyEventSchemas = [...MoneyEventV1Schemas, exports.SettlementAdjustmentReversedV2.schema];
exports.MoneyEventSchema = zod_1.z.union([
    zod_1.z.discriminatedUnion('type', MoneyEventV1Schemas),
    exports.SettlementAdjustmentReversedV2.schema,
]);
function parseMoneyEvent(input) {
    return exports.MoneyEventSchema.parse(input);
}
function assertParticipantTerms(ctx, role, id, percentage) {
    if (id !== undefined && percentage === undefined) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: [`${role}Percentage`],
            message: `${role} exige percentual`,
        });
    }
    if (id === undefined && percentage !== undefined) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: [`${role}Id`],
            message: `${role} percentual exige participante`,
        });
    }
}
//# sourceMappingURL=money-events.js.map